import { customElement, property } from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { personalAdvisingStyles } from './personal-advising.styles'

@customElement('sbk-personal-advising')
export class SbkPersonalAdvising extends LitElement {

  @property()
  heading: string = '';

  @property({ attribute: 'person-name' })
  personName: string = '';

  @property({ attribute: 'job-title' })
  jobTitle: string = '';

  @property()
  href: string = '';

  @property({ attribute: 'button-label' })
  buttonLabel: string = '';

  @property({ type: Number, attribute: 'with-image', reflect: true }) withImage?: number = 1;

  @property()
  size: 'default' | 'small' | 'small-image' = 'default';

  @property()
  variant: 'default' | 'reverse' = 'default';

  static get styles() {
    return personalAdvisingStyles;
  }

  firstUpdated() {
    const slot = this.shadowRoot!.querySelector('slot[name="image"]') as HTMLSlotElement;
    if (!slot || slot.assignedNodes().length === 0) {
      (this.shadowRoot!.querySelector('.personal-advising__wrapper') as HTMLSlotElement).classList.add('no-img');
    }
    const slotIntroduction = this.shadowRoot!.querySelector('slot[name="introduction"]') as HTMLSlotElement;
    if (!slotIntroduction || slotIntroduction.assignedNodes().length === 0) {
      (this.shadowRoot!.querySelector('.personal-advising__wrapper') as HTMLSlotElement).classList.add('no-introduction');
    }
  }

  render() {
    return html`
      <div class="personal-advising__wrapper personal-advising__wrapper--${this.size} personal-advising--${this.variant}">
        ${this.renderHeadline()}
        <div class="personal-advising__introduction-wrapper">
          <slot name="introduction"></slot>
        </div>

        ${this.withImage === 1 ? html`
            <div class="person__container">
              <div class="image-container">
                <div class="half-circle-small"></div>
                <div class="half-circle"></div>
                <slot class="personal-advising__image" name="image"></slot>
              </div>
              ${this.personName || this.jobTitle ? html`
                    <div class="personal-advising__person-info">
                      ${this.renderName()}
                      ${this.renderJobTitle()}
                    </div>
                  `
          : ''}
            </div>
          `
        : ''}

        <div class="personal-advising__body-wrapper">
          <div class="personal-advising__body-button-wrapper">
            <div>
              <slot></slot>
            </div>
            ${this.renderLink()}
          </div>
        </div>
      </div>
    `;
  }

  renderHeadline() {
    return this.heading
      ? html`
          <div class="personal-advising__headline-wrapper">
            <p class="personal-advising__headline">${this.heading}</p>
          </div>
        ` : '';
  }

  renderLink() {
    return this.href && this.buttonLabel
      ? html`<div>
          <sbk-button href=${this.href}>${this.buttonLabel}</sbk-button>
        </div>`
      : '';
  }

  renderName() {
    return this.personName
      ? html`<p class="personal-advising__name">${this.personName}</p>`
      : '';
  }

  renderJobTitle() {
    return this.jobTitle
      ? html`<p class="personal-advising__job-title">${this.jobTitle}</p>`
      : '';
  }

}